module.exports = __webpack_public_path__ + "img/lorry.9a4c127c.svg";